import { IState } from '../store';
import { isSuburbanOfferFromBuilder } from '../utils/suburban';

export const isVillagePromotionsShown = (state: IState): boolean => {
  return !!(state.promotionsVillageData?.promotions?.length > 0) && isSuburbanOfferFromBuilder(state.offerData.offer);
};
